// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-success[data-v-59b1c852] {\r\n  color: #19a974;\n}\n.was-Invalidated[data-v-59b1c852] {\r\n  border-color: #dc3545;\n}\n.contracts-box[data-v-59b1c852] .bg-secondary-3,\r\n.contracts-box[data-v-59b1c852] .bg-container {\r\n  background-color: #fff !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
